import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "back": function ($event) {
        return _vm.$emit('reset-type');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('NiotaClassic.Originators.form.titleUpdate') : _vm.$i18n_t('NiotaClassic.Originators.form.titleCreate')) + "\n    " + _vm._s(_vm.formItem.id ? ` - ${_vm.formItem.title}` : '') + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("\n      " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('Common.save') : _vm.$i18n_t('Common.saveAndCreate')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "justify": "center"
    }
  }, [_c('div', [_c('div', {
    staticClass: "image-upload-wrapper",
    on: {
      "click": function ($event) {
        return _vm.$refs.attachmentInput.click();
      }
    }
  }, [_c('img', {
    staticClass: "image-upload-img",
    attrs: {
      "src": _vm.formItem.image ? _vm.niota1ImageUrl(_vm.formItem.image) : 'img/niota-classic/placeholder.png'
    }
  }), _c('input', {
    ref: "attachmentInput",
    staticStyle: {
      "visibility": "hidden",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": _vm.imageInputChanged
    }
  })])])]), _c(VCol, {
    attrs: {
      "cols": "8",
      "sm": "4"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.title'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.title,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "title", $$v);
      },
      expression: "formItem.title"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.type'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "value": _vm.selectedOriginatorType,
      "hide-details": "auto",
      "disabled": "",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('img', {
          staticClass: "data-source-icon",
          attrs: {
            "src": `img/niota-classic/datasources/${_vm.dataSourcesData[_vm.formItem.type].image}`,
            "alt": _vm.dataSourcesData[_vm.formItem.type].name || _vm.formItem.type,
            "title": _vm.dataSourcesData[_vm.formItem.type].name || _vm.formItem.type
          }
        })];
      },
      proxy: true
    }])
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "autofocus": false,
      "hide-details": "auto"
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.account'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "items": _vm.accounts,
      "item-text": "name",
      "hide-details": "auto",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.name))]), _c(VListItemSubtitle, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Common.table.id')) + ": " + _vm._s(data.item.id) + "\n                ")])], 1)];
      }
    }]),
    model: {
      value: _vm.formItem.account,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "account", $$v);
      },
      expression: "formItem.account"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSelect, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.datasource'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "items": _vm.dataSourcesForType,
      "item-text": "source",
      "hide-details": "auto",
      "return-object": ""
    },
    on: {
      "change": _vm.handleDataSourceChange
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.source))]), _c(VListItemSubtitle, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Common.table.id')) + ": " + _vm._s(data.item.id) + "\n                ")])], 1)];
      }
    }]),
    model: {
      value: _vm.formItem.datasource,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "datasource", $$v);
      },
      expression: "formItem.datasource"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Originators.form.datasource_text', {
    type: _vm.selectedOriginatorType
  })) + "\n          ")])], 1), _vm.formConfig.user ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.user'),
      "rules": _vm.formConfig.user.requiredRule,
      "hide-details": "auto",
      "autocomplete": "new-password",
      "name": "config_user",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.user,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "user", $$v);
      },
      expression: "formItem.user"
    }
  }), _vm.formConfig.user.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.user.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.password ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('core-password-field', {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.password'),
      "rules": _vm.formConfig.password.requiredRule,
      "hide-details": "auto",
      "autocomplete": "new-password",
      "name": "config_password",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.password,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "password", $$v);
      },
      expression: "formItem.password"
    }
  }), _vm.formConfig.password.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.password.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.apiKey ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.apiKey'),
      "rules": _vm.formConfig.apiKey.requiredRule,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.apiKey,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "apiKey", $$v);
      },
      expression: "formItem.apiKey"
    }
  }), _vm.formConfig.apiKey.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.apiKey.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.polling_interval ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.polling_intervall'),
      "rules": _vm.formConfig.polling_interval.requiredRule,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.options.polling_intervall,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "polling_intervall", $$v);
      },
      expression: "formItem.options.polling_intervall"
    }
  }), _vm.formConfig.polling_interval.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.polling_interval.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.temetra_api_key ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.temetra_api_key'),
      "rules": _vm.formConfig.temetra_api_key.requiredRule,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.options.temetra_api_key,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "temetra_api_key", $$v);
      },
      expression: "formItem.options.temetra_api_key"
    }
  }), _vm.formConfig.temetra_api_key.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.temetra_api_key.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.target_profile ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.target_profile'),
      "rules": _vm.formConfig.target_profile.requiredRule,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.options.target_profile,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "target_profile", $$v);
      },
      expression: "formItem.options.target_profile"
    }
  }), _vm.formConfig.target_profile.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.target_profile.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.act_login ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.act_login'),
      "rules": _vm.formConfig.act_login.requiredRule,
      "hide-details": "auto",
      "autocomplete": "new-password",
      "name": "config_login",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.options.login,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "login", $$v);
      },
      expression: "formItem.options.login"
    }
  }), _vm.formConfig.act_login.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.act_login.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.act_password ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('core-password-field', {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.act_password'),
      "rules": _vm.formConfig.act_password.requiredRule,
      "hide-details": "auto",
      "autocomplete": "new-password",
      "name": "config_password",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.options.password,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "password", $$v);
      },
      expression: "formItem.options.password"
    }
  }), _vm.formConfig.act_password.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.act_password.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.formate ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.formate'),
      "rules": _vm.formConfig.formate.requiredRule,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "items": ['xml'],
      "hide-details": "auto"
    },
    model: {
      value: _vm.formItem.options.formate,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "formate", $$v);
      },
      expression: "formItem.options.formate"
    }
  }), _vm.formConfig.formate.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.formate.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.import_path ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.import_path'),
      "rules": _vm.formConfig.import_path.requiredRule,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.options.import_path,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "import_path", $$v);
      },
      expression: "formItem.options.import_path"
    }
  }), _vm.formConfig.import_path.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.import_path.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.xslt ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.xslt'),
      "rules": _vm.formConfig.xslt.requiredRule,
      "autofocus": false,
      "hide-details": "auto"
    },
    model: {
      value: _vm.formItem.options.xslt,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "xslt", $$v);
      },
      expression: "formItem.options.xslt"
    }
  }), _c('markdown-it-vue-light', {
    staticClass: "mt-2",
    attrs: {
      "content": _vm.formConfig.xslt.help
    }
  })], 1) : _vm._e(), _vm.formConfig.import_api_key ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.import_api_key'),
      "rules": _vm.formConfig.import_api_key.requiredRule,
      "hide-details": "auto",
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: _vm.formItem.options.import_api_key,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "import_api_key", $$v);
      },
      expression: "formItem.options.import_api_key"
    }
  }), _vm.formConfig.import_api_key.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.import_api_key.help) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm.formConfig.import_api_key ? _c(VCol, {
    staticClass: "pt-0 mt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.Originators.form.import_api_key_text'))
    }
  }), _c('span', {
    ref: "import_api_key",
    staticClass: "monospace"
  }, [_vm._v(_vm._s(_vm.webhookApiPath))]), _c(VIcon, {
    staticClass: "ml-1",
    attrs: {
      "color": _vm.color,
      "size": "16"
    },
    on: {
      "click": function ($event) {
        return _vm.copyToClipboard('import_api_key');
      }
    }
  }, [_vm._v("\n            fal fa-copy\n          ")])], 1) : _vm._e(), _vm.formConfig.transform_template ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Originators.form.transform_template'),
      "autofocus": false,
      "hide-details": "auto"
    },
    model: {
      value: _vm.formItem.options.transform_template,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.options, "transform_template", $$v);
      },
      expression: "formItem.options.transform_template"
    }
  }), _vm.formConfig.transform_template.help ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.formConfig.transform_template.help) + "\n          ")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };